// TODO: check if it is right place for it
export type OverrideReportRequestPayload = {
  startDate: string;
  endDate: string;
  adjustment: number;
  mappings: number[];
};

/*
 * Override Template (Override Report Config)
 */

export type OverrideReportConfigTemplateFieldValue =
  | string
  | number
  | boolean
  | null
  | OverrideReportConfigTemplateFieldValue[]
  | { [key: string]: OverrideReportConfigTemplateFieldValue };

export type OverrideReportConfigTemplateField = {
  key: string;
  value: OverrideReportConfigTemplateFieldValue;
  editable: boolean;
};

export type OverrideReportConfigTemplateData = {
  fields: OverrideReportConfigTemplateField[];
};

export type CreateOverrideReportConfigTemplatePayload = {
  name: string;
  data: OverrideReportConfigTemplateData;
};

export type UpdateOverrideReportConfigTemplatePayload = {
  name: string;
  data: OverrideReportConfigTemplateData;
};

export type OverrideTemplateSessionDataFieldPayload = {
  key: string;
  value: OverrideReportConfigTemplateFieldValue;
};

export type OverrideTemplateSessionDataPayload = {
  fields: OverrideTemplateSessionDataFieldPayload[];
};

export type UpsertOverrideTemplateSessionPayload = {
  data?: OverrideTemplateSessionDataPayload;
};

export type BulkItemUpsertOverrideTemplateSessionPayload = UpsertOverrideTemplateSessionPayload & {
  templateId: number;
};

export type BulkUpsertOverrideTemplateSessionRequest = {
  items: BulkItemUpsertOverrideTemplateSessionPayload[];
};

export type RunOverrideTemplateSessionReportRequest = {
  sessionId: number;
  templateId: number;
};

export const OVERRIDE_REPORT_DISPLAY_FIELDS = [
  'Agency',
  'Agent',
  'Product Name',
  'Policy #',
  'Life Premium',
  'Target Premium',
  'Annuity',
] as const;

export type OverrideReportDisplayField = (typeof OVERRIDE_REPORT_DISPLAY_FIELDS)[number];

/*
 * Agency Mappings
 */

export type AgencyMappingMutatePayload = {
  display_name?: string;
  transactions_of: string;
  override_id: number;
};

/**
 * Override Session Report
 */

export const OverrideReportingSessionTemplateTransactionSortByValues = [
  'agentAsc',
  'annuityAsc',
  'annuityDesc',
  'lifeAsc',
  'lifeDesc',
  'targetAsc',
  'targetDesc',
] as const;

export type OverrideReportingSessionTemplateTransactionSortBy =
  (typeof OverrideReportingSessionTemplateTransactionSortByValues)[number];

/**
 * Override Session Report Notes
 */
export type OverrideSessionReportNotePayload = {
  text: string;
};
